export enum TaskStatus {
    UPLOADING = "uploading",
    GENERATING = "generating",
    IDLE = "idle",
    FAILED = 'failed',
    DELETING = 'deleting'
}
